import AsyncImage from "../core/AsyncImage";
import { GameScene } from "../scenes/GameScene";
import { DecorationCategory } from "../ui/DecorationMenu";
import AsyncDraggableButton from "./AsyncDraggableButton";
import { DecorationData } from "./DecorationData";
import TransformController from "./TransformController";

export default class Decoration extends AsyncDraggableButton {
	// private static readonly thumbnailScale = 3.03;
	decorationData: DecorationData;
	category: DecorationCategory;
	sticker: boolean;
	masked = false;

	constructor(scene: GameScene, x: number, y: number, decoration: DecorationData, category: DecorationCategory) {
		super(scene, x, y, decoration.path, decoration.id);
		this.decorationData = decoration;
		this.category = category;
		const isLoaded = this.status == 'loaded';
		if (decoration.id == "whiteSquare") this.setDisplaySize(200, 200);
		// else if (decoration.scale && decoration.scale.inital) {
		// 	if (isLoaded) this.setScale(decoration.scale.inital);
		// 	else {
		// 		// const initalScale = decoration.scale.inital * Decoration.thumbnailScale;
		// 		// console.log("inital Scale: " + initalScale);
		// 		this.setScale(initalScale);
		// 	}
		// } 
		// else if (!isLoaded) this.setScale(Decoration.thumbnailScale);
		if (this.decorationData.tint) this.tint = Number.parseInt(decoration.tint);
		if (!isLoaded) {
			this.once(
				AsyncImage.LOAD_COMPLETE,
				() => {
					const scale = this.scale;// / Decoration.thumbnailScale;
					this.setScale(0);
					scene.tweens.killTweensOf(scene.transformController);
					scene.transformController.setControllerScale(0);
					scene.tweens.add({
						targets: [this],
						scale: scale,
						duration: 400,
						ease: Phaser.Math.Easing.Back.Out,
						onUpdate: () => {
							scene.transformController.setControllerScale(this.scale);
						}
					});
				},
				this
			);
		}

		if(category == "dolls") {
			this.setOrigin(0.51, 0.18);
			this.setInteractive(scene.input.makePixelPerfect(150));
		}

		this.sticker = (category == "stickers")
	}

	setTransformSettings(controller: TransformController): void {
			const isLoaded = this.status == 'loaded';
			const scale = this.decorationData.scale;
			const min = scale && scale.min ? scale.min : 0.25;
			const tempMin = isLoaded ? min : min; // * Decoration.thumbnailScale;
			const max = scale && scale.max ? scale.max : 4;
			const tempMax = isLoaded ? max : max; // * Decoration.thumbnailScale;

			controller.setMinScale(tempMin);
			controller.setMaxScale(tempMax);
			if (!isLoaded)
				this.once(AsyncImage.LOAD_COMPLETE, () => {
					if (!controller.isSelectedObj(this)) return;
					controller.setMinScale(min);
					controller.setMaxScale(max);
				});
	}

	getWorldBounds(): Phaser.Geom.Rectangle {
		const transform = this.getWorldTransformMatrix();
		const size = new Phaser.Math.Vector2(transform.scaleX, transform.scaleY);
		size.x *= this.width;
		size.y *= this.height;
		return new Phaser.Geom.Rectangle(transform.tx - size.x / 2, transform.ty - size.y / 2, size.x, size.y);
	}
}
